'use strict';
/* eslint-env browser */

module.exports = function (buf) {
  var formData = new FormData();
  formData.append('file', new Blob([buf], {
    type: 'application/octet-stream'
  }));
  return formData;
};